import HttpBackend from "i18next-http-backend";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { supportedLanguageCodes } from "./supportedLanguages";
import CustomerTranslations from "../utils/CustomerTranslations";

const getLocalisationUrls = () => {
  const runtimeEnv = process.env.RUNTIME_ENV ?? "development";
  const urls = {
    staticTranslationUrl: "http://localhost:8000/locales",
    customerTranslationUrl: "http://localhost:6969",
  };

  // These code paths can never be hit by tests
  /* istanbul ignore next */
  if (runtimeEnv === "production") {
    urls.staticTranslationUrl = "https://localisation.appointedd.com";
    urls.customerTranslationUrl =
      "https://customer-translations.appointedd.com";
  } else if (runtimeEnv === "t2") {
    urls.staticTranslationUrl = "https://localisation-t2.appointedd.com";
    urls.customerTranslationUrl =
      "https://customer-translations-t2.appointedd.com";
  } else if (runtimeEnv === "t1") {
    urls.staticTranslationUrl = "https://localisation-t1.appointedd.com";
    urls.customerTranslationUrl =
      "https://customer-translations-t1.appointedd.com";
  }
  return urls;
};

const { staticTranslationUrl, customerTranslationUrl } = getLocalisationUrls();

const ns = ["common", CustomerTranslations.getNamespace()];

void i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpBackend)
  .init({
    backend: {
      loadPath: (lng, ns) => {
        const namespace = Array.isArray(ns) ? ns[0] : ns;
        if (namespace === CustomerTranslations.getNamespace()) {
          return `${customerTranslationUrl}/${ns}/${lng}`;
        }
        return `${staticTranslationUrl}/booking-tools/${lng}/${ns}.json`;
      },
      allowMultiLoading: false,
    },
    debug: process.env.NODE_ENV === "development",
    defaultNS: "common",
    detection: {
      caches: [],
      lookupQuerystring: "locale",
      convertDetectedLanguage: (lng: string) => {
        if (lng === "en") {
          return "en-GB";
        }
        if (lng === "no" || lng === "nn") {
          // Our Norwegian translations default to Bokmål, for some reason
          // so we need to ensure this is always selected for norwegian detection
          return "nb";
        }
        return lng;
      },
    },
    fallbackLng: ["en-US", "en-GB"],
    interpolation: {
      escapeValue: false,
    },
    load: "all",
    nonExplicitSupportedLngs: true,
    ns,
    supportedLngs: [...supportedLanguageCodes, "en", "cimode"],
  });

/**
 * Convenience function to set the translation engine to display keys only.
 * Useful for tests.
 */
export async function setTranslationTestMode(): Promise<void> {
  await i18n.changeLanguage("cimode");
}

export default i18n;
